import { makeAutoObservable } from 'mobx';
import { Entity } from '../../lib/base/viewModels';

export class EntityList<TEntity extends Entity<TId>, TId = TEntity['id']> {
  private entities: Array<TEntity>;
  private filter?: (e: TEntity) => boolean;

  constructor() {
    this.entities = new Array<TEntity>();
    makeAutoObservable(this);
  }

  public add(entity: TEntity) {
    if (entity.id == undefined || this.entities.some((e) => e.id == entity.id)) return;
    this.entities.unshift(entity);
  }

  public remove(entity: TEntity) {
    if (entity.id == undefined) throw new Error("can't remove entity without id");
    this.entities = this.entities.filter((e) => e.id != entity.id);
  }

  public readPage(page: number, pageSize: number) {
    return this.read(pageSize, page * pageSize);
  }

  public read(limit: number, offset: number) {
    let result = this.entities;
    if (this.filter) {
      result = result.filter(this.filter);
    }

    return result.slice(offset, limit + offset);
  }

  public some(predicate: (entity: TEntity) => boolean) {
    return this.entities.some(predicate);
  }

  public setFilter(predicate: (e: TEntity) => boolean) {
    this.filter = predicate;
  }

  public clearFilter() {
    this.filter = undefined;
  }

  public get length() {
    return this.entities.length;
  }

  public get all() {
    return this.entities;
  }

  public clear() {
    this.entities = new Array<TEntity>();
    this.clearFilter();
  }
}
